/**
 * Labstep
 *
 * @module components/Organization/Settings
 * @desc Organization settings
 */

import { OrganizationFormShowEditName } from 'labstep-web/components/Organization/Form/ShowEdit/Name';
import { OrganizationSettingsAllowMemberCreateGroup } from 'labstep-web/components/Organization/Settings/AllowMemberCreateGroup';
import { OrganizationSettingsMfa } from 'labstep-web/components/Organization/Settings/Mfa';
import { OrganizationSettingsSso } from 'labstep-web/components/Organization/Settings/Sso';
import { OrganizationSettingsWhitelistIp } from 'labstep-web/components/Organization/Settings/WhitelistIp';
import { HorizontalTable } from 'labstep-web/core/Table/Horizontal';
import type { TableHorizontalProps } from 'labstep-web/core/Table/Horizontal/types';
import type { Organization } from 'labstep-web/models/organization.model';
import type React from 'react';
import type { OrganizationSettingsProps } from './types';

export const getRows = (
  organization: Organization,
): TableHorizontalProps['rows'] => {
  const rows = [
    {
      header: 'Name',
      content: (): React.ReactNode => (
        <OrganizationFormShowEditName organization={organization} />
      ),
    },
    {
      header: 'Single Sign On',
      content: (): React.ReactNode => (
        <OrganizationSettingsSso organization={organization} />
      ),
    },
    {
      header: 'Two Factor Authentication',
      content: (): React.ReactNode => (
        <OrganizationSettingsMfa organization={organization} />
      ),
    },
    {
      header: 'IP Whitelist',
      content: (): React.ReactNode => (
        <OrganizationSettingsWhitelistIp
          organization={organization}
        />
      ),
    },
    {
      header: 'Workspaces',
      content: (): React.ReactNode => (
        <OrganizationSettingsAllowMemberCreateGroup
          organization={organization}
        />
      ),
    },
  ];

  return rows;
};

export const OrganizationSettings: React.FC<
  OrganizationSettingsProps
> = ({ organization }) => (
  <div id="organization-settings">
    <HorizontalTable
      padded
      headerProps={{ width: 3 }}
      rows={getRows(organization)}
      columns={[organization]}
    />
  </div>
);
